import React, { createContext, useContext } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var DropdownContext = /*#__PURE__*/createContext({
  size: 'small',
  multiselect: true
});
export var DropdownContextProvider = function DropdownContextProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  return ___EmotionJSX(DropdownContext.Provider, {
    value: value
  }, children);
};
var useDropdownContext = function useDropdownContext() {
  var context = useContext(DropdownContext);
  if (context === undefined) {
    throw new Error('useDropdownContext must be used within Dropdown component.');
  }
  return context;
};
export default useDropdownContext;